import cx from 'classnames'
import { Heading } from 'blaze-ui/Heading/Heading'
import Styles from './Panel.module.scss'
import { PanelProps } from './Types'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { Close } from 'almanac-ui/icons'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

const MobilePanel = ({ children }: PanelProps) => {
  return <>{children}</>
}

const Panel = ({ title, onClose, filled = false, children }: PanelProps) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()

  return (
    <div className={cx(Styles.panel, { [Styles.filled]: filled })}>
      <div className={Styles.header}>
        <Heading level={isSystemRedesignEnabled ? 5 : 4}>{title}</Heading>
        <div className={Styles.closeButton}>
          <IconButton aria-label="Close" icon={Close} size="xs" variant="tertiary" onPress={() => onClose()} />
        </div>
      </div>
      {children}
    </div>
  )
}

const PanelContainer = (props: PanelProps) => {
  const { isMobile } = useResponsiveDesign()

  return isMobile ? <MobilePanel {...props} /> : <Panel {...props} />
}

export { PanelContainer as Panel }
